Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const INTEGRATION_NAME = 'VercelAI';

exports.INTEGRATION_NAME = INTEGRATION_NAME;
//# sourceMappingURL=constants.js.map
